'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _InputField = require('./InputField');

var _InputField2 = _interopRequireDefault(_InputField);

var _InputAffix = require('./InputAffix');

var _InputAffix2 = _interopRequireDefault(_InputAffix);

var _InputInset = require('./InputInset');

var _InputInset2 = _interopRequireDefault(_InputInset);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _Feedback = require('./Feedback');

var _Feedback2 = _interopRequireDefault(_Feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(props) {
    var label = props.label,
        labelClassNames = props.labelClassNames,
        _props$id = props.id,
        id = _props$id === undefined ? (0, _idGen2.default)('input') : _props$id,
        error = props.error,
        required = props.required,
        prefix = props.prefix,
        postfix = props.postfix,
        insetLeft = props.insetLeft,
        insetRight = props.insetRight,
        classNames = props.classNames,
        _props$className = props.className,
        className = _props$className === undefined ? classNames : _props$className;

    var isAffix = prefix || postfix;
    var isInset = insetLeft || insetRight;
    var formFieldClassNames = (0, _classnames2.default)('luna-form__field', {
        'is-invalid': error
    }, className);
    var input = isAffix ? _react2.default.createElement(_InputAffix2.default, Object.assign({}, props, { id: id })) : _react2.default.createElement(_InputField2.default, Object.assign({}, props, { id: id }));
    return _react2.default.createElement("div", { className: formFieldClassNames }, _react2.default.createElement(_Label2.default, { label: label, labelClassNames: labelClassNames, required: required, id: id }), isInset ? _react2.default.createElement(_InputInset2.default, Object.assign({}, props, { id: id, isAffix: isAffix })) : input, error && _react2.default.createElement(_Feedback2.default, { error: error, id: id }));
};
Input.propTypes = {
    label: _propTypes2.default.node.isRequired,
    labelClassNames: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
    onKeyDown: _propTypes2.default.func.isRequired,
    placeholder: _propTypes2.default.string.isRequired,
    required: _propTypes2.default.bool,
    prefix: _propTypes2.default.string.isRequired,
    postfix: _propTypes2.default.string.isRequired,
    insetLeft: _propTypes2.default.node.isRequired,
    insetRight: _propTypes2.default.node.isRequired,
    type: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    classNames: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired
};
Input.defaultProps = {
    type: 'text',
    error: false,
    required: false
};
exports.default = Input;
//# sourceMappingURL=Input.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/Input.js